import { defineComponent as f, computed as l, openBlock as d, createBlock as p, unref as s, normalizeStyle as T, normalizeClass as g, createSlots as O, withCtx as t, renderSlot as a, createCommentVNode as v, createVNode as _ } from "vue";
import { NTooltip as w } from "naive-ui";
import { JSONtoNaiveVars as i } from "./highrise.es266.js";
import "./highrise.es53.js";
import { TOOLTIP_HEADER_STYLES as E, TOOLTIP_CONTENT_STYLES as N, createTooltipTheme as C, TOOLTIP_STYLE_OVERRIDES as L } from "./highrise.es468.js";
import { COMPONENT_NAME as $ } from "./highrise.es166.js";
import u from "./highrise.es153.js";
/* empty css               */
const I = f({
  name: $.TOOLTIP,
  inheritAttrs: !1
}), D = /* @__PURE__ */ f({
  ...I,
  props: {
    trigger: { default: "hover" },
    placement: { default: void 0 },
    show: { type: Boolean, default: void 0 },
    variant: { default: "light" },
    headerStyle: { default: () => ({}) },
    contentStyle: { default: () => ({}) },
    tooltipStyle: { default: () => ({}) }
  },
  emits: ["show"],
  setup(h) {
    const o = h, y = l(() => ({
      ...E,
      ...o.headerStyle
    })), c = l(() => ({
      ...N,
      ...o.contentStyle
    })), S = l(() => ({
      ...i(L),
      ...i(C(o.variant)),
      ...i(o.tooltipStyle)
    }));
    return (e, n) => {
      var m;
      return d(), p(s(w), {
        trigger: e.trigger,
        show: e.show,
        placement: e.placement,
        "header-style": y.value,
        "content-style": c.value,
        style: T(S.value),
        class: g(["hr-tooltip"]),
        "onUpdate:show": n[0] || (n[0] = (r) => e.$emit("show", r))
      }, O({
        trigger: t(() => [
          a(e.$slots, "trigger")
        ]),
        default: t(() => {
          var r;
          return [
            (r = e.$slots) != null && r.default ? (d(), p(s(u), {
              key: 0,
              size: "sm",
              weight: "medium",
              class: "hr-tooltip__content"
            }, {
              default: t(() => [
                a(e.$slots, "default")
              ]),
              _: 3
            })) : v("", !0)
          ];
        }),
        _: 2
      }, [
        (m = e.$slots) != null && m.header ? {
          name: "header",
          fn: t(() => [
            _(s(u), {
              size: "sm",
              weight: "semibold"
            }, {
              default: t(() => [
                a(e.$slots, "header")
              ]),
              _: 3
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["trigger", "show", "placement", "header-style", "content-style", "style"]);
    };
  }
});
export {
  D as default
};
//# sourceMappingURL=highrise.es158.js.map
